import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const stylesByVariant = {
  success: {
    wrapper: "bg-[#7DD3B0] text-[#0F3D36]",
  },
  error: {
    wrapper: "bg-[#D04A56] text-white",
  },
};

export default function Toast({
  open,
  variant = "success",
  message,
  onClose,
  autoHideMs = 2000,
  className = "",
}) {
  const { t } = useTranslation();

  useEffect(() => {
    if (!open) return;

    if (!autoHideMs) return;
    const t = setTimeout(() => onClose?.(), autoHideMs);
    return () => clearTimeout(t);
  }, [open, autoHideMs, onClose]);

  if (!open) return null;

  const v = stylesByVariant[variant] ?? stylesByVariant.success;

  return (
    <div
      role="alert"
      className={[
        "fixed left-1/2 -translate-x-1/2 bottom-24 z-[60]",
        "w-[calc(100%-2rem)] sm:w-[calc(100%-3rem)] max-w-6xl",
        "rounded-lg shadow-lg",
        v.wrapper,
        className,
      ].join(" ")}
    >
      <div className="flex items-center justify-between px-6 py-4">
        <p className="text-sm font-medium">{message}</p>

        <button
          type="button"
          onClick={onClose}
          className="ml-4 text-lg leading-none opacity-90 hover:opacity-100"
          aria-label={t("ACTIONS.CLOSE")}
        >
          &times;
        </button>
      </div>
    </div>
  );
}
